export const styleguides = [
  {
    id: 'default',
    name: 'Candu Default',
    styleguide: {},
    Additional: () => null,
  },
];
